/**
 * 所有的 ajax 请求，都要使用该组件进行
 * @author zhangpeng
 */

import axios from 'axios'
import event from './event'
import tryParseJson from '@/fn/tryParseJson'
import { AjaxResult } from '@/util/types'
import qs from 'qs'

const ajaxBaseUrl = VAR.ajaxBaseUrl

const isAbsoluteUrl = (url: string) => /^[a-z][a-z0-9+.-]*:/.test(url)

const emit = (data: any) => {
  event.emit(`ajax${data.s}`, data)
  return data
}

// 确保最终的数据，始终有值
const perfectData = ({ s, data, msg }: any = {}) => {
  return {
    s,
    data: data || {},
    msg: msg || '',
  }
}

const request = async (url: string, opts: object): Promise<AjaxResult> => {
  const isAbs = isAbsoluteUrl(url)

  const config = {
    baseURL: isAbs ? '' : ajaxBaseUrl,
    url,
    withCredentials: true,
    ...opts,
  }

  let res: any

  try {
    res = await axios(config)
  } catch (ex) {
    if (ex && ex.response) {
      const { status, data: html } = ex.response
      const error: any = { s: status, data: { html }, msg: 'HTTP Error' }
      // 对 500 进一步处理
      if (status == 500) {
        res = {
          data: tryParseJson(html, error)
        }
      } else {
        throw emit(error)
      }
    } else {
      const msg = ex && ex.message || 'Unknown Error'
      throw emit({ s: 810, data: { ex }, msg })
    }
  }

  const { data } = res
  if (data && data.s !== undefined) {
    const result = perfectData(data)
    if (data.s == 200) {
      return result
    } else {
      throw emit(result)
    }
  } else {
    throw emit({ s: 800, data: { raw: data }, msg: 'Data Format Error' })
  }
}

export async function get(url: string, data?: object, opts?: object) {
  return request(url, {
    method: 'get',
    params: {
      ...data,
      _: Date.now(),
    },
    ...opts,
  })
}

export async function post(url: string, data?: object, opts?: object) {
  return request(url, {
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    ...opts,
  })
}

export async function put(url: string, data?: object, opts?: object) {
  return request(url, {
    method: 'put',
    data,
    ...opts,
  })
}

export async function del(url: string, data?: object, opts?: object) {
  return request(url, {
    method: 'delete',
    data,
    ...opts,
  })
}
